import React from 'react';
import ImageWithPlaceholder from '../../../shared/components/image-with-placeholder';
import Link from '../../../shared/components/hyperlink';
import { Helpers } from '../../../core/src/helpers';
import QuantityPicker from '../../../product/components/quantity-picker';

import '../../css/cart-preview.less';
import '../../css/new-cart-preview.less';

const EMPTY_ARRAY = [];

export const OldCartProducts = ({ cartInfo, handleQtyChange, maxCartItems }) => {
    const { items = EMPTY_ARRAY } = cartInfo;
    let displayItems = items.slice(0, maxCartItems);
    return displayItems.map((item, idx) => {
        let _cItem = Object.assign({}, item);
        let { pType, subType } = item || {};
        let isGiftcard = ['PGC', 'VGC'].includes(pType);
        const isFree = item.amt.fg && item.amt.nAmt == 0;
        const linkType = 'absolute';
        const onsale = Helpers.convertPriceToNumber(item.amt.iPrice) > Helpers.convertPriceToNumber(item.amt.nAmt);
        return (
            <div key={`idx-${item.pNum}`} className={`productrow${idx === 0 ? ' first-prod' : ''}`}>
                <Link to={item.pdpUrl} linkType={linkType} className="mcprodimg">
                    <ImageWithPlaceholder src={Helpers.getCDNUrl('', item.img, 300)} />
                </Link>
                <div className="mcprodname">
                    <Link
                        to={item.pdpUrl}
                        linkType={linkType}
                        dangerouslySetInnerHTML={{ __html: Helpers.decodeHtml(item.name) }}
                    ></Link>
                    <span>{item.pNum}</span>
                </div>
                <div className={`mcprodqty${isFree ? ' free' : ''}${isGiftcard ? ' giftcard-cart-item' : ''}`}>
                    <span>
                        <label htmlFor={'qty_' + idx}> QTY:</label>
                    </span>
                    {isFree || isGiftcard ? (
                        <div className="no-select-qty">{item.qty}</div>
                    ) : (
                        <QuantityPicker
                            quantity={item.qty}
                            onPick={handleQtyChange}
                            checkInitialQty={false}
                            updateQuantityFromProps={true}
                            quantityMax={9}
                            quantityMin={0}
                            args={[item]}
                            enabled={true}
                            quantityOptions={subType === 'VCP' && [0, item.qty]}
                            data-metrics-event-name={'linkClick'}
                            data-metrics-event={'e_linkClick'}
                            data-metrics-link-id={'cartPreview:qty-selector:orig'}
                        />
                    )}
                    {isGiftcard && (
                        <span
                            className="item-remove remove-giftcard-cart-item"
                            onClick={() => handleQtyChange(0, item)}
                        >
                            Remove
                        </span>
                    )}
                </div>
                <div className="mcprodprice">
                    {item.amt.fg || !onsale ? null : (
                        <span className="strike">{item.amt.iPrice ? '$' + item.amt.iPrice : ''}</span>
                    )}
                    {isFree ? <span>Free</span> : <span>{item.amt.nAmt ? '$' + item.amt.nAmt : ''}</span>}
                </div>
            </div>
        );
    });
};

/*new version, not in use, keep here in case need to revert in the future*/
export const NewCartProducts = ({ cartInfo, handleQtyChange, maxCartItems }) => {
    const { items = EMPTY_ARRAY } = cartInfo;
    let displayItems = items.slice(0, maxCartItems);
    return displayItems.map((item, idx) => {
        let _cItem = Object.assign({}, item);
        let { pType } = item || {};
        let isGiftcard = ['PGC', 'VGC'].includes(pType);
        const isFree = item.amt.fg && item.amt.nAmt == 0;
        const linkType = 'absolute';
        const onsale = Helpers.convertPriceToNumber(item.amt.iPrice) > Helpers.convertPriceToNumber(item.amt.nAmt);
        return (
            <div key={`idx-${item.pNum}`} className={`productrow${idx === 0 ? ' first-prod' : ''}`}>
                <Link to={item.pdpUrl} linkType={linkType} className="mcprodimg">
                    <ImageWithPlaceholder src={Helpers.getCDNUrl('', item.img, 300)} />
                </Link>
                <div className="mcprodname">
                    <Link
                        to={item.pdpUrl}
                        linkType={linkType}
                        dangerouslySetInnerHTML={{ __html: Helpers.decodeHtml(item.name) }}
                    ></Link>
                    <span>{item.pNum}</span>
                </div>
                <div className={`mcprodqty${isFree ? ' free' : ''}`}>
                    {isFree ? (
                        <div className="no-select-qty">{item.qty}</div>
                    ) : (
                        <QuantityPicker
                            quantity={item.qty}
                            onPick={handleQtyChange}
                            checkInitialQty={false}
                            quantityMax={9}
                            quantityMin={0}
                            args={[item]}
                            enabled={true}
                            data-metrics-event-name={'linkClick'}
                            data-metrics-event={'e_linkClick'}
                            data-metrics-link-id={'cartPreview:qty-selector:var1'}
                        />
                    )}
                    {isGiftcard && (
                        <span
                            className="item-remove remove-giftcard-cart-item"
                            onClick={() => handleQtyChange(0, item)}
                        >
                            Remove
                        </span>
                    )}
                </div>
                <div className="mcprodprice">
                    {item.amt.fg || !onsale ? null : (
                        <span className="strike">{item.amt.iPrice ? '$' + item.amt.iPrice : ''}</span>
                    )}
                    {isFree ? <span>Free</span> : <span>{item.amt.nAmt ? '$' + item.amt.nAmt : ''}</span>}
                    {!isFree && (
                        <span className="remove" onClick={() => handleQtyChange(0, _cItem)}>
                            Remove
                        </span>
                    )}
                </div>
            </div>
        );
    });
};
